export const getCookie = (name) => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

export const setCookie = (name, value, days) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; path=/; expires=${d.toUTCString()}; Secure; SameSite=None;`;
};

export const deleteCookie = (name) => {
  const expires = new Date(0).toUTCString();
  document.cookie = `${name}=; expires=${expires}; path=/;`;
};
